module.exports = __webpack_public_path__ + "26ca72362cf166258263ead3e82fd146.svg";